import { noFilteredMatchesCount$$, snapshotLoaded$$, sportByName$$ } from '../push/overview/subs';
import { useReframe } from 'nike-re-framejs';
import { clientLog } from '../../../common/logging/logs';
import { PushJSLog } from '../../../common/logging/push/PushJSLog';
import { contractNumber$ } from '../../../common/h&s';

const useLogNotLoadedData = sportName => {
    const derefSub = useReframe();
    const isSnapshotLoaded = derefSub(snapshotLoaded$$(sportName));

    if (isSnapshotLoaded) {
        const sport = derefSub(sportByName$$(sportName));
        const matchCountFromSport = sport?.get('matchCount');
        const matchCountFromOverview = derefSub(noFilteredMatchesCount$$(sportName));
        if (matchCountFromSport > 0 && (!matchCountFromOverview || matchCountFromOverview === 0)) {
            const contractNumber = derefSub(contractNumber$()) || 'anonymous';
            const data = {
                sportName,
                contractNumber
            };

            clientLog(
                PushJSLog({
                    message: `TurboLive overview data for sport ${sportName} not loaded`,
                    data: data
                })
            );
        }
    }
};

export default useLogNotLoadedData;
